const backfillPendingInvoices = async (db: IDBDatabase) => {
  // Step 1: Get all pending invoices from old store
  let pendingInvoicesToMigrate: (PendingInvoiceSchema & {
    isNotSynced?: boolean;
  })[] = [];

  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(["pendingInvoices"], "readonly");
    const request = tx.objectStore("pendingInvoices").getAll();

    request.onsuccess = () => {
      pendingInvoicesToMigrate = request.result || [];
      resolve();
    };

    request.onerror = () => {
      reject(new Error("Failed to get pending invoices"));
    };
  });

  // Step 2: Get all invoices from old store
  let invoicesToMigrate: (InvoiceSchema & { isNotSynced?: boolean })[] = [];
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(["invoices"], "readonly");
    const request = tx.objectStore("invoices").getAll();

    request.onsuccess = () => {
      invoicesToMigrate = request.result || [];
      resolve();
    };

    request.onerror = () => {
      reject(new Error("Failed to get invoices"));
    };
  });

  // Step 3: Migrate pending invoices to new store
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(["pendingInvoicesV2"], "readwrite");
    const store = tx.objectStore("pendingInvoicesV2");

    const total = pendingInvoicesToMigrate.length;

    if (total === 0) {
      resolve();
      return;
    }

    tx.oncomplete = () => {
      resolve();
    };

    tx.onerror = () => {
      reject(new Error("Failed to migrate pending invoices"));
    };

    for (const { isNotSynced, ...invoice } of pendingInvoicesToMigrate) {
      store.add({
        ...invoice,
        id: invoice?.id ?? crypto.randomUUID(),
      });
    }
  });

  // Step 4: Migrate invoices to new store
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(["invoicesV2"], "readwrite");
    const store = tx.objectStore("invoicesV2");

    const total = invoicesToMigrate.length;

    if (total === 0) {
      resolve();
      return;
    }

    tx.oncomplete = () => {
      resolve();
    };

    tx.onerror = () => {
      reject(new Error("Failed to migrate invoices"));
    };

    for (let i = 0; i < invoicesToMigrate.length; i++) {
      const { isNotSynced, ...invoice } = invoicesToMigrate[i];
      store.add({
        ...invoice,
        id: invoice?.id ?? i.toString(),
      });
    }
  });
};

export default backfillPendingInvoices;
